import type { RouteRecordRaw } from 'vue-router'
import LoginForm from '../../components/js/Components/Login/LoginForm.vue'
import TwoFactorForm from '../../components/js/Components/Login/TwoFactorForm.vue'
import { Routes } from '../../Constants/Routes.ts'
import LoginPage from '../../Views/LoginPage.vue'
import { assertThat } from '../Guards'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: LoginPage,
    meta: {
      guards: assertThat().notAuthenticated(),
    },
    children: [
      {
        path: '',
        name: Routes.LOGIN,
        component: LoginForm,
      },
      {
        path: 'mfa',
        name: Routes.LOGIN_MFA,
        component: TwoFactorForm,
      },
    ],
  },
]

export default routes
